import { useEffect, useState } from "react";
import { fetchData } from "../common/services/ApiClient";
import {
  generateFinancialsApiUrl,
  top100Banks,
} from "../components/FinancialReporting/FinancialReportingUtilities";
import { KeyValue, Query } from "../interfaces";

export default function useGetTop100Certs(
  appState: Query,
  institutions?: boolean,
  finishedCall?: (call: boolean) => void,
) {
  const [top100Certs, setTop100Certs] = useState<string[]>([]);
  const [prevAppState, setPrevAppState] = useState<KeyValue>();

  useEffect(() => {
    const newAppState = appState
      ? {
          filters: appState.filters,
          search: appState.search,
          pagination: appState.pagination,
          sort: appState.sort,
          reportStructure: appState.ui.reportStructure,
        }
      : {};
    if (
      appState &&
      //prevents from making too many calls
      JSON.stringify(newAppState) !== JSON.stringify(prevAppState) &&
      appState.filters.commonSearch &&
      top100Banks(appState.filters.commonSearch)
    ) {
      //if multiple reportPeriods exist, this finds the one that changed to pass in for the financials call, otherwise it will always get the first report in the array
      const reportPeriod = appState.filters.reportPeriod.filter(
        (report: string) =>
          prevAppState && !prevAppState.filters.reportPeriod.includes(report),
      );

      setPrevAppState(newAppState);

      (async () => {
        await fetchData(
          `${generateFinancialsApiUrl(
            {
              ...appState,
              filters: {
                ...appState.filters,
                reportPeriod:
                  //if the different report is identified, use that, otherwise default to standard appstate
                  reportPeriod.length === 1
                    ? reportPeriod
                    : appState.filters.reportPeriod,
              },
            },
            undefined,
            "",
            institutions,
          )}&sort_by=ASSET&sort_order=desc&limit=100&offset=0`,
        )
          .then(response => {
            const arrayOfCerts = response.data.map((val: KeyValue) => val.CERT);
            setTop100Certs(arrayOfCerts);
          })
          .catch((error: Error) => console.error(error))
          //if we pass in the state to determine when the call has been completed, we pass that state once it is done.
          .finally(() => finishedCall && finishedCall(true));
      })();
    }
  }, [appState, finishedCall, institutions, prevAppState]);

  return top100Certs;
}
